import Item from "../../layers/dto/Item";
import { FeatureCollection } from "../../core/geo/types";

class GeoCalculationItem extends Item {
    geometry?: FeatureCollection;
    constructor(item: Item, geometry?: FeatureCollection) {
        super(
            item.id,
            item.name,
            item.visibility,
            item.expanded,
            item.group,
            item.removable,
            item.children,
            item.parent
        );
        this.geometry = geometry;
    }
}

export default GeoCalculationItem;
